export default __webpack_public_path__ + "navigation-examples-predictive-caching-960-b796a184703533662996f05fa273cf5b.webp";